/**
 * FormField Component
 *
 * A wrapper for form inputs that provides consistent labeling, error messages, and help text.
 */

import React from 'react';
import { cn } from '@lognai/synapse-design-system-v1';

export interface FormFieldProps {
  label: string;
  children: React.ReactNode;
  required?: boolean;
  error?: string;
  helpText?: string;
  htmlFor?: string;
  className?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  children,
  required = false,
  error,
  helpText,
  htmlFor,
  className,
}) => {
  return (
    <div className={cn('flex flex-col gap-2 mb-4', className)}>
      <label htmlFor={htmlFor} className="text-sm font-medium text-foreground flex gap-1">
        {label}
        {required && <span className="text-destructive">*</span>}
      </label>
      {children}
      {error && <p className="text-sm text-destructive m-0">{error}</p>}
      {helpText && !error && <p className="text-sm text-muted-foreground m-0">{helpText}</p>}
    </div>
  );
};

export default FormField;
